import Loader from "@/atoms-react/loader/Loader.react";
import { jwtDecode } from "@/features/auth/invalid-token-error";
import { jwtPayload } from "@/features/auth/types";
import { setJwt } from "@/features/auth/utils";
import { isIOS } from "@/features/partner/utils";
import { isAllowedOrigin } from "@/features/utils/domains";
import { usei18n } from "@/features/utils/hooks/use-i18n";
import { useAppDispatch } from "@/redux/hooks";
import { setExpirationToken, setLinkedCompanies, setRoles } from "@/redux/slices/userSlice";
import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export const ChangePartner = () => {
  const [searchParams] = useSearchParams();
  const { setLanguage } = usei18n();
  const dispatch = useAppDispatch();
  useEffect(() => {
    const handleToken = (message: MessageEvent) => {
      if (!isAllowedOrigin(message.origin)) {
        return window.parent.postMessage("ERROR", message.origin);
      }

      const lang = searchParams.get("lang");
      const theme = searchParams.get("theme");
      const data = JSON.parse(message.data);
      const { token, refresh, email } = data;
      if (token) {
        if (isIOS()) {
          let expires = "";
          const date = new Date();
          date.setTime(date.getTime() + 1000 * 60);
          expires = "; expires=" + date.toUTCString();
          document.cookie =
            "jwt_cookie" +
            "=" +
            JSON.stringify({
              token: token,
              refresh: refresh
            }) +
            expires +
            "; path=/";
        } else {
          setJwt({
            token: token
          });
          const decoded: jwtPayload = jwtDecode(token);
          const { exp, roles, linked_companies } = decoded;
          if (roles) dispatch(setRoles({ roles: roles }));
          dispatch(setLinkedCompanies({ linkedCompanies: linked_companies }));

          dispatch(setExpirationToken(Number(exp)));
        }
        if (email) sessionStorage.setItem("username", email);

        if (lang) {
          setLanguage(lang);
        }
        if (theme) localStorage.setItem("theme", theme);

        window.parent.postMessage("RECEIVED", message.origin);
      }
    };
    window.addEventListener("message", handleToken);

    return () => window.removeEventListener("message", handleToken);
  }, [window]);

  return (
    <div className="flex h-full w-full flex-row justify-center">
      <div className="flex h-full flex-col justify-center">
        <Loader />
      </div>
    </div>
  );
};
